// extracted by mini-css-extract-plugin
export var zoom = "ZoomImageProvider-module--zoom--2Bd3J";
export var image = "ZoomImageProvider-module--image--_g6b9";